import api from './api';

const cropService = {
  getAllCrops: async (companyId = null) => {
    const params = {};
    if (companyId) params.companyId = companyId;
    const response = await api.get('/crops/all', { params });
    return response.data;
  },
  getCrops: async (page = 1, limit = 10, search = '', companyId = null) => {
    const params = { page, limit };
    if (search) params.search = search;
    if (companyId) params.companyId = companyId;
    const response = await api.get('/crops', { params });
    return response.data;
  },
  createCrop: async (data) => (await api.post('/crops', data)).data,
  updateCrop: async (id, data) => (await api.post(`/crops/${id}`, data)).data,
  deleteCrop: async (id) => (await api.delete(`/crops/${id}`)).data,
};

export default cropService;